import { formatCustomDate } from "helpers/dateTools";

export const columns = [
  {
    Header: "Nombre",
    accessor: "name",
    filterable: true,
    filterMethod: (filter, row) => row.name?.toLowerCase().includes(filter.value.toLowerCase())
  },
  {
    Header: "Periodo de pago",
    accessor: "periodCalc",
    filterable: true,
    filterMethod: (filter, row) => row.periodCalc?.toLowerCase().includes(filter.value.toLowerCase())
  },
  {
    Header: "Fecha inicio",
    accessor: "startDate",
    filterable: true,
    filterMethod: (filter, row) => row.startDate?.toLowerCase().includes(filter.value.toLowerCase()),
    Cell: ({ value }) => formatCustomDate(value, "-")
  },
  {
    Header: "Vigencia",
    accessor: "endDate",
    filterable: true,
    filterMethod: (filter, row) => row.endDate?.toLowerCase().includes(filter.value.toLowerCase()),
    Cell: ({ value }) => formatCustomDate(value, "-")
  },
  {
    Header: "Variantes",
    accessor: "variantsNum",
    filterable: true,
    filterMethod: (filter, row) => String(row.variantsNum)?.toLowerCase().includes(filter.value.toLowerCase())
  },
];